export enum MessageTypes {
    REQUEST_SECURE_SYNC = 0,
    LOAD_COMPLETE = 1,
    UPDATE_COMPLETE = 2,
    UNAUTHORIZED = 3,
    FORBIDDEN = 4,
    INTERNAL_ERROR = 5,
    NOT_FOUND = 6,
    UNKNOWN = 7,
    CONFIGURATION = 8
}
